import { button, any, string, IOWidget, Action, nothing, Route, route, Widget, mkWidget, AsyncState } from "widgets-for-react";
import { AppState, isLoggedInState, LoginState } from "./portal/state";
import { home } from "./portal/pages/home.mod";
import { LoginFlowClasses } from "./portal/pages/style.mod";
import { CustomRouteParams } from "./portal/router_state";
import { QuotationRequest, Product, ProductConfiguration, QuotationResponse, Characteristic, RequestToRetry } from './portal/types';
import React = require("react");
import * as Immutable from "immutable"

export type State = {
  quotation_request: QuotationRequest,
  products: AsyncState<Product[]>,
  quotation_response: AsyncState<QuotationResponse>
  showProducts: boolean,
  productConfigurations: Immutable.Map<string, ProductConfiguration>,
  selectedProductConfiguration: string,
  isPanelOpen? : boolean
  isAlertTypeOpen : {
    cancelConfiguration: boolean,
    connectionErrorServer: boolean,
    connectionErrorUser: boolean,
    editCharacteristic: boolean,
    logout: boolean,
    quotationSubmit: boolean,
    deleteProduct: boolean
  },
  language_code: string,
  editCharateristicId: string
  deleteProductConfigurationKey: string
  cachedCharacteristics: Characteristic[]
  errorMessages: string[]
  toRetry: RequestToRetry,
  inDarkMode: boolean
 }
export type ExtraUserInfo = { firstname?: string, lastname?: string, company?: string, SAPId?: string}


//add here your custom route definitions.
export type CustomRoutes =
  | {kind:"product_configurator", id:number}

export type PortalRouteParams = CustomRouteParams<CustomRoutes>

export let custom_routes_unauthorized : Route<PortalRouteParams>[] =
  //add here your custom routes.
  [
    route<{id:string}, PortalRouteParams>("/hellocustom/:id", a => ({kind:"product_configurator", id:a.id && parseInt(a.id)}))
  ]

export let custom_routes_authorized : Route<PortalRouteParams>[] =
  //add here your custom authorized routes.
  [
  ]

//add here what to do/show when a custom route is catched. As this method must return a widget, when no custom route is selected
//defaultWidget is returned and rendered. By default the defaulWidget is the login widget, which renderes also the application when loggedin
export let page_when_custom_routes_unauthorized = (s:AppState<State, PortalRouteParams, ExtraUserInfo>, defaultWidget:Widget<Action<AppState<State, PortalRouteParams, ExtraUserInfo>>>) : Widget<Action<AppState<State, PortalRouteParams, ExtraUserInfo>>> => {
  switch(s.route.kind){
    case  "product_configurator":
      let id = s.route.id
      return mkWidget({run: _ => <div>
        <div>ID: {id}</div>
        <div>KIND: {s.route.kind}</div>
      </div>})
    default:
      return defaultWidget
  }
}


export let application = (rootpath:string): IOWidget<AppState<State, PortalRouteParams, ExtraUserInfo>, Action<AppState<State, PortalRouteParams, ExtraUserInfo>>> => (s0: AppState<State, PortalRouteParams, ExtraUserInfo>) =>
  home(rootpath, { style: LoginFlowClasses })(s0)
